namespace Riepiloghi.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
